export const URLS = {
	publicPath: process.env.PUBLIC_URL,
};
